import type { SlowSection } from '@/types';
import type { PickingInfo } from '@deck.gl/core';

import { DEPTH, MAPPINGS, SLOW_SECTION_LAYER, TRAIN_DIAMETER_LARGE } from '@/utils/constants/map';
import { getAtlases } from '@/utils/helpers/train-simulation/get-atlases';
import { makeIconLayer } from '@/utils/helpers/train-simulation/make-icon-layer';

export default function getSlowSectionDeckLayers(
  slowSectionData: SlowSection[],
  onClick: (info: PickingInfo) => boolean | void,
  isVisible: boolean,
  isLarge: boolean
) {
  const atlases = getAtlases();

  if (!slowSectionData?.length) {
    return [];
  }

  const getPosition = (d: SlowSection): [number, number] => {
    const midpoint = d.midpoint || [0, 0];

    return [Number(midpoint[0]), Number(midpoint[1])];
  };

  const layers = [];

  if (atlases) {
    layers.push(
      makeIconLayer<SlowSection>({
        id: SLOW_SECTION_LAYER,
        data: slowSectionData,
        visible: isVisible,
        pickable: true,
        onClick,
        offset: isLarge ? [0, 0] : [0, 10],
        atlas: isLarge ? atlases.slowSectionLarge : atlases.slowSectionSmall,
        mapping: MAPPINGS.SLOW_SECTION,
        icon: 'marker',
        getPosition,
        color: [255, 255, 255],
        size: isLarge ? TRAIN_DIAMETER_LARGE : 20,
        depth: DEPTH.CIRCLE,
      })
    );
  }

  return layers;
}
